import { transformRoutes } from '@backoffice-frontend/common'

const BaseStatusAreaRoutes = {
  route: '/status',
}

export const StatusAreaRoutes = transformRoutes(BaseStatusAreaRoutes)
